import { Icon } from './Icon'
import { Logotype } from './Logotype'
import { EMAIL, INSTAGRAM, WHATSAPP_LABEL, linkWhatsApp } from '../config'

const NAVEGACAO = [
  { texto: 'Início', href: '#inicio' },
  { texto: 'Estruturação', href: '#plataformas' },
  { texto: 'Produtos', href: '#ecossistema' },
  { texto: 'Sobre', href: '#sobre' },
  { texto: 'Contato', href: '#contato' },
]

const PLATAFORMAS = [
  { texto: 'iFood', href: '#plataformas' },
  { texto: '99 Food', href: '#plataformas' },
  { texto: 'Cardápio Digital', href: '#ecossistema' },
]

export function Footer() {
  return (
    <footer className="footer">
      <div className="shell footer__top">
        <div className="footer__brand">
          <Logotype grande />
          <p>Tecnologia e gestão<br />para restaurantes reais.</p>
        </div>

        <nav className="footer__col" aria-label="Navegação">
          <h4>Navegação</h4>
          {NAVEGACAO.map((l) => <a href={l.href} key={l.texto}>{l.texto}</a>)}
        </nav>

        <nav className="footer__col" aria-label="Plataformas">
          <h4>Plataformas</h4>
          {PLATAFORMAS.map((l) => <a href={l.href} key={l.texto}>{l.texto}</a>)}
        </nav>

        <div className="footer__col footer__col--contact">
          <h4>Contato</h4>
          <a href={linkWhatsApp()}><Icon name="wa" />{WHATSAPP_LABEL}</a>
          <a href={`mailto:${EMAIL}`}><Icon name="mail" />{EMAIL}</a>
          <a href={`https://instagram.com/${INSTAGRAM}`} target="_blank" rel="noopener">
            <Icon name="ig" />@{INSTAGRAM}
          </a>
          <p><Icon name="pin" /><span>Curitiba - PR<br />Atendimento em todo o Brasil</span></p>
        </div>

        {/* Parceiro. A logo ja vem com fundo transparente e nas cores claras da
            marca, entao fica legivel sobre o azul escuro sem precisar de caixa.
            width/height reservam o espaco e evitam o texto pular quando ela entra. */}
        <div className="footer__partner">
          <h4>Parceiro de marketing digital</h4>
          <img src="/assets/img/otimizei.webp" alt="Otimizei" width={640} height={180} loading="lazy" decoding="async" />
          <p>Marketing digital e<br />presença online.</p>
        </div>

        <span className="script script--7">Caminhamos ao lado<br />de quem quer crescer.</span>
      </div>

      <div className="shell footer__bottom">
        <p>&copy; {new Date().getFullYear()} Skyenex. Todos os direitos reservados.</p>
        {/* Sem link enquanto as paginas nao existem: um href="#" levaria o
            visitante de volta ao topo, o que e pior do que nao ser clicavel. */}
        <p className="footer__legal">
          <span className="em-breve">Política de Privacidade</span>
          <span aria-hidden="true">|</span>
          <span className="em-breve">Termos de Uso</span>
        </p>
      </div>
    </footer>
  )
}
